export default __webpack_public_path__ + "static/media/Self_server_tool.18a23100.svg";